import { Component, HostListener, OnInit } from '@angular/core';
import {SpinnerService} from '../spinner.service'
import { Subscription } from 'rxjs';
declare var $: any;
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
  a:Subscription
  b:Subscription
  screen=''
  meassage=''
  constructor(private spinnerService:SpinnerService) {
    this.a=this.spinnerService.showClickEvent().subscribe((value)=>{
      this.screen=value.screen
      this.meassage=value.meassage
      this.show()
    })
    this.b=this.spinnerService.hideClickEvent().subscribe((b)=>{
      this.hide()
    })
   }
  ngOnInit() {
  }
 
  @HostListener('document:keydown', ['$event']) 
  KeyBord(event: KeyboardEvent) {
    if(!this.isSpinnerHide){
      event.preventDefault()
    }
  }
  isSpinnerHide = false

  show(){
    // console.log('this is show method')
      this.isSpinnerHide=false
  } 

  hide(){
    // console.log('this is hide method')
    this.isSpinnerHide = true
  }
}
